import { useParams } from "react-router-dom";
import { useMemo } from "react"; // Added useMemo
import { getUrl } from '../../App';
import { useQuery } from '@tanstack/react-query';
import GameCard from "../GameCard/GameCard.jsx";
import GameCardOther from "../GameCard/GameCardOther.jsx";
import SkeletonCard from '@shared/components/SkeletonCard/SkeletonCard';
import styles from './GameListView.module.css';

const fetch_games = async (id) => {
    const response = await fetch(`${getUrl()}/api/games/?event=${id}`,{credentials: 'include', });
    
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return await response.json();
}

function GameListView() {
    // get the event id from the url
    const { id } = useParams();

    const games = useQuery({
        queryKey: ['games', id], queryFn: () => fetch_games(id),
        staleTime: 5 * 60 * 1000, // Cache data for 5 minutes
        cacheTime: 5 * 60 * 1000,
    });

    if (games.isError) {
        return <div>Error fetching logs: {games.error.message}</div>;
    }

    // We calculate these inside the component body. 
    // They will automatically re-run once 'data' is no longer undefined.
    const berlinGames = useMemo(() => {
        if (!games.data) return [];
        return games.data
            .filter(game => game.team1 === 3 || game.team2 === 3)
            .sort((a, b) => a.start_time.localeCompare(b.start_time));
    }, [games.data]);

    const otherGames = useMemo(() => {
        if (!games.data) return [];
        return games.data
            .filter(game => game.team1 !== 3 && game.team2 !== 3)
            .sort((a, b) => a.start_time.localeCompare(b.start_time));
    }, [games.data]);

    return (
        <div className={styles.view_content}>
            <div className="panel-header">
                <h3>GameView</h3>
            </div>
            <div className={styles.projects_section}>
                <div className={`${styles.project_boxes}`}>
                <div className={`${styles.jsGridView}`}>
                    {games.isLoading ? (
                        <>
                            <SkeletonCard />
                            <SkeletonCard />
                            <SkeletonCard />
                        </>
                    ) : berlinGames.length > 0 ? (
                        berlinGames.map((game) => (
                                <GameCard
                                    game={game}
                                    key={game.id}
                                ></GameCard>
                            ))
                    ) : (
                        <div className={styles.emptyState}>
                            No games found
                        </div>
                    )}

                </div>
                <hr className={styles.line}></hr>
                <div className={`${styles.jsGridView}`}>
                    {games.isLoading ? (
                        <>
                            <SkeletonCard />
                            <SkeletonCard />
                            <SkeletonCard />
                        </>
                    ) : otherGames.length > 0 ? (
                        otherGames.map((game) => (
                                <GameCardOther
                                    game={game}
                                    key={game.id}
                                ></GameCardOther>
                            ))
                    ) : (
                        <div className={styles.emptyState}>
                            No further games found
                        </div>
                    )}

                </div>
                </div>
            </div>
            
            
        </div>
    );
}

export default GameListView;